import { useMemo } from 'react';

import { TFunction, useTranslation } from '@mint-lib/i18n';
import { usePermissions } from '@mint-lib/profile-helpers';

import { Button } from '@myn/mui';

import { PERMISSIONS_MAP } from '../../constants.js';
import { useModal } from '../../context/ModalContext/useModal.js';
import useTab, { RouteTabs } from '../../hooks/useTab/useTab.js';

export const CreateModalLabelMap: (
  t: TFunction,
) => Record<RouteTabs, string> = (t: TFunction) => ({
  [RouteTabs.User]: t('New user'),
  [RouteTabs.Role]: t('New role'),
});

const AddButton = () => {
  const { t } = useTranslation('@myn/permissions');

  const { setOpen: setIsNewModalOpened } = useModal();

  const activeRoute = useTab();

  const { getPermissionField } = usePermissions();

  const isReadonlyPermission = useMemo(
    () =>
      getPermissionField('usersPermissionsFeature') === PERMISSIONS_MAP.View,
    [getPermissionField('usersPermissionsFeature')],
  );

  const label = CreateModalLabelMap(t)[activeRoute ?? RouteTabs.User];

  return isReadonlyPermission ? null : (
    <Button
      variant="contained"
      color="primary"
      size="large"
      onClick={() => setIsNewModalOpened(true)}
      startIcon={'Add'}
      aria-label="open add modal"
    >
      {label}
    </Button>
  );
};

export default AddButton;
